export type PlaidGateMode = "free_trial" | "paywall_first";

export const PLAID_GATE_MODE_DEFAULT: PlaidGateMode = "free_trial";
export const PLAID_FREE_TRIAL_DAYS_DEFAULT = 30;

export function parsePlaidGateMode(
  raw: string | undefined | null,
): PlaidGateMode {
  return raw === "paywall_first" ? "paywall_first" : PLAID_GATE_MODE_DEFAULT;
}

export function parsePlaidFreeTrialDays(
  raw: string | number | undefined | null,
): number {
  const n = typeof raw === "number" ? raw : Number(raw);
  return Number.isFinite(n) && n > 0
    ? Math.floor(n)
    : PLAID_FREE_TRIAL_DAYS_DEFAULT;
}

export interface PlaidGateRemoteConfig {
  mode: PlaidGateMode;
  freeTrialDays: number;
}
